import { WardApiClient } from '../client';
import { WardNotification } from '../types';

export class WardSignalService {
  private static api = WardApiClient.getInstance();

  /**
   * Get the count of unread mails for the current student
   */
  static async getNotifications(): Promise<WardNotification> {
    const response = await this.api.get<WardNotification>('/signals');
    return response.data;
  }
}
